import { render, staticRenderFns } from "./SidebarSettings.vue?vue&type=template&id=5df8abe9&scoped=true&"
import script from "./SidebarSettings.vue?vue&type=script&lang=js&"
export * from "./SidebarSettings.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSettings.vue?vue&type=style&index=0&id=5df8abe9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df8abe9",
  null
  
)

export default component.exports